import React from "react";
import addressImage from "../assets/address.png"; // Import the address image

function Contact() {
  return (
    <section id="contact" style={{ padding: "20px" }}>
      <h2
        style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "30px",
          color: "#333",
          textTransform: "uppercase", // Make the title unique
          borderBottom: "2px solid #ffd700", // Add a unique underline
          display: "inline-block",
          paddingBottom: "10px",
        }}
      >
        Бидэнтэй холбоо барих
      </h2>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap", // Ensure responsiveness
          gap: "20px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Image Section */}
        <div style={{ flex: "1 1 40%", textAlign: "center" }}>
          <img
            src={addressImage}
            alt="Address Location"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "10px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Add a subtle shadow
            }}
          />
        </div>

        {/* Text Section */}
        <div style={{ flex: "1 1 50%", color: "#333" }}>
          <p style={{ marginBottom: "15px", fontSize: "1rem", lineHeight: "1.6" }}>
            <strong>Хаяг:</strong>{" "}
            <a
              href="https://maps.app.goo.gl/rBwVQ9adug2FxE3a9"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none" }}
            >
              Улаанбаатар хот, Сүхбаатар дүүрэг, 6 дугаар хороо, “Метро бизнес центр”
              барилгын 7 давхар 704 тоот
            </a>
          </p>
          <p style={{ marginBottom: "15px", fontSize: "1rem", lineHeight: "1.6" }}>
            <strong>Утас:</strong>{" "}
            <a href="tel:+97699996756" style={{ color: "#007BFF", textDecoration: "none" }}>
              99996756
            </a>
          </p>
          <p style={{ marginBottom: "15px", fontSize: "1rem", lineHeight: "1.6" }}>
            <strong>Имэйл:</strong>{" "}
            <a
              href="mailto:Uandbadvocates@gmail.com"
              style={{ color: "#007BFF", textDecoration: "none" }}
            >
              Uandbadvocates@gmail.com
            </a>
          </p>
          <p style={{ marginBottom: "15px", fontSize: "1rem", lineHeight: "1.6" }}>
            <strong>Фэйсбүүк:</strong>{" "}
            <a
              href="https://www.facebook.com/profile.php?id=61569707858011"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none" }}
            >
              Өмгөөллийн U&B адвокатс хуулийн фирм
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default Contact;